import baseBackendApi from "../../main/configuration/baseBackendApi";

export const allVideoOfTheDay = async () => {
    const response = baseBackendApi.get("songs/videooftheday/day");
    return response;
}